'use client';

import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface IBlockProps {
  children: React.ReactNode;
  theme?: 'default' | 'lightest' | 'lighter' | 'light' | 'medium' | 'dark' | 'category01' | 'category02' | 'category03' | 'category04';
  width?: 'default' | 'narrow' | 'medium' | 'article' | 'max' | 'full' | 'search';
  compact?: boolean;
  className?: string;
}

const Block: React.FunctionComponent<IBlockProps> = (props) => {
  return (
    <div
      className={classNames(
        'block',
        {
          ['theme-default']: props.theme === 'default' || !props.theme,
          ['theme-lightest']: props.theme === 'lightest',
          ['theme-lighter']: props.theme === 'lighter',
          ['theme-light']: props.theme === 'light',
          ['theme-medium']: props.theme === 'medium',
          ['theme-dark']: props.theme === 'dark',
          ['theme-category01']: props.theme === 'category01',
          ['theme-category02']: props.theme === 'category02',
          ['theme-category03']: props.theme === 'category03',
          ['theme-category04']: props.theme === 'category04',

          ['width-default']: props.width === 'default' || !props.width,
          ['width-narrow']: props.width === 'narrow',
          ['width-medium']: props.width === 'medium',
          ['width-article']: props.width === 'article',
          ['width-max']: props.width === 'max',
          ['width-full']: props.width === 'full',
          ['width-search']: props.width === 'search',

          ['compact']: props.compact,
        },
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};

Block.displayName = 'Block';

export default Block;
